import { useAtomValue } from "jotai/index";
import type { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { RATIONS } from "@/interface/WidgetMenu/ui/FrameAspectRatioMenu/constants";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UseFrameAspectRatioButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useFrameAspectRatioButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseFrameAspectRatioButtonProps): MenuOptionResult {
    const { t } = useTranslation();
    const options = useAtomValue(widgetMenuOptionsByNameAtom("frameAspectRatio")) ?? [];
    const isActive = activeSubMenu?.name === "frameAspectRatio";
    const firstOptionValue = options[0]?.value;

    const DEFAULT_RATIO = RATIONS.find((r) => r.value === "custom") ?? RATIONS[RATIONS.length - 1];

    const label = RATIONS.find((r) => r.value === firstOptionValue)?.label ?? DEFAULT_RATIO.label;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "frameAspectRatio" ? null : { name: "frameAspectRatio", anchor: button },
        );
    };

    const content = (
        <span
            style={{ fontWeight: 300, maxHeight: "20px", color: isActive ? "#0D99FF" : "#2C2D32" }}
        >
            {label}
        </span>
    );
    const tippyContent = t("widgetTooltips.frameAspectRatio");

    return {
        content,
        handleClick,
        isActive,
        tippyContent,
    };
}
